export const mockedData = {
  crewMemberId: '123456',
  shipCode: 'AL',
  signOnDate: '20991201',
};
